export enum ExternalSystemTypes {
  Epic = 'epic'
}

export enum ExternalIdSuffixes {
  EpicOSW = 'epic_osw'
}
